class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.onAjaxAdded = this.onAjaxAdded.bind(this);
    this.onCartRefresh = this.onCartRefresh.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    // Initial lazy-load
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    // ✅ Fix: re-render/open drawer after cart changes
    document.addEventListener('ajaxProduct:added', this.onAjaxAdded);

    // Support a generic refresh trigger (useful for apps/custom code)
    document.addEventListener('cart:refresh', this.onCartRefresh);
    document.addEventListener('cartdrawer:refresh', this.onCartRefresh);
  }

  disconnectedCallback() {
    document.removeEventListener('ajaxProduct:added', this.onAjaxAdded);
    document.removeEventListener('cart:refresh', this.onCartRefresh);
    document.removeEventListener('cartdrawer:refresh', this.onCartRefresh);
  }

  onAjaxAdded() {
    // After an AJAX add-to-cart, refresh sections and open drawer
    this.refresh({ open: true });
  }

  onCartRefresh(event) {
    const detail = event?.detail || {};
    this.refresh({ open: !!detail.open });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => console.error(e));
  }

  /**
   * ✅ New: refresh the mini-cart + bubbles using Shopify "sections" endpoint
   */
  refresh({ open = false } = {}) {
    const sectionIds = this.getSectionsToRender().map(s => s.section);

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}?sections=${encodeURIComponent(sectionIds.join(','))}`;

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(sections => {
        // Re-render each target element
        this.getSectionsToRender().forEach(section => {
          const el = document.getElementById(section.id);
          if (!el) return;

          const sectionHtml = sections[section.section];
          if (!sectionHtml) return;

          el.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        });

        if (open) this.open();
      })
      .catch(e => console.error(e));
  }

  open() {
    if (!this.drawer) return;

    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement && detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

(function () {
  const triggerMiniCartRefresh = () => {
    const miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.refresh === 'function') {
      miniCart.refresh({ open: true });
    }
  };

  // --- Hook fetch() ---
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const method = (args[1] && args[1].method ? String(args[1].method) : 'GET').toUpperCase();

      // Shopify add-to-cart endpoints (theme/app)
      if (
        method === 'POST' &&
        (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
      ) {
        // Wait for the request to complete, then refresh drawer
        triggerMiniCartRefresh();
      }
    } catch (e) {}

    return res;
  };

  // --- Hook XMLHttpRequest (some themes/apps use this) ---
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__cartMethod = method ? String(method).toUpperCase() : '';
    this.__cartUrl = url || '';
    return origOpen.call(this, method, url, ...rest);
  };

  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        if (
          this.__cartMethod === 'POST' &&
          (String(this.__cartUrl).includes('/cart/add') ||
            String(this.__cartUrl).includes('/cart/change') ||
            String(this.__cartUrl).includes('/cart/update'))
        ) {
          triggerMiniCartRefresh();
        }
      } catch (e) {}
    });

    return origSend.apply(this, args);
  };
})();

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-upsell-add="true"]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  const qty = parseInt(btn.dataset.qty || '3', 10);

  if (!variantId || !Number.isInteger(qty) || qty < 1) return;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: qty
      })
    });

    const miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.refresh === 'function') {
      miniCart.refresh({ open: true });
    }
  } catch (err) {
    console.error('Upsell add failed', err);
  }
}, true); // ← capture phase to override theme logic
